import {
  ProfileState,
} from '@/store/modules/profile/types';

export const state: ProfileState = {
  data: {},
  isLoaded: false,
};
